import { FETCH_IMPCS_OF_SINGLE_INBOUND_OPERATOR_SUCCESS, FETCH_IMPCS_OF_SINGLE_OUTBOUND_OPERATOR_SUCCESS } from '../actions/types/ImpcsOfSingleOperatorActionsTypes';

export const initialState = {
  inboundImpcs: [],
  outboundImpcs: [],
};

export const impcsOfSingleOperatorReducer = (state = initialState, action) => {
  switch (action.type) {
  case FETCH_IMPCS_OF_SINGLE_INBOUND_OPERATOR_SUCCESS:
    return {
      ...state,
      inboundImpcs: action.payload,
    };
  case FETCH_IMPCS_OF_SINGLE_OUTBOUND_OPERATOR_SUCCESS:
    return {
      ...state,
      outboundImpcs: action.payload,
    };
  default:
    return state;
  }
};
